import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import fr from './locales/fr.json';
import ar from './locales/ar.json';
import pt from './locales/pt.json';

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  ar: { translation: ar },
  pt: { translation: pt },
};

// RTL languages
export const RTL_LANGUAGES = ['ar'];

// Language options for the switcher
export const LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português', flag: '🇵🇹' },
];

// Helper to check if current language is RTL
export const isRTL = (lang) => RTL_LANGUAGES.includes(lang);

// Update document direction based on language
export const updateDirection = (lang) => {
  if (typeof document === 'undefined') return;
  const dir = isRTL(lang) ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lang;
  
  // Add/remove RTL class for CSS styling
  if (isRTL(lang)) {
    document.documentElement.classList.add('rtl');
  } else {
    document.documentElement.classList.remove('rtl');
  }
};

// Initialize with default language first
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Start with English
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'ar', 'pt'],
    load: 'languageOnly',
    debug: false,
    
    interpolation: {
      escapeValue: false,
    },
    
    react: {
      useSuspense: false,
    },
  });

// Check localStorage and change language after initialization
if (typeof window !== 'undefined') {
  try {
    const stored = localStorage.getItem('atff_language');
    if (stored && ['en', 'fr', 'ar', 'pt'].includes(stored) && stored !== i18n.language) {
      i18n.changeLanguage(stored);
    }
  } catch (e) {
    // localStorage not available
  }
  updateDirection(i18n.language);
}

// Update direction when language changes
i18n.on('languageChanged', (lang) => {
  updateDirection(lang);
  if (typeof window !== 'undefined') {
    try {
      localStorage.setItem('atff_language', lang);
    } catch (e) {
      // localStorage not available
    }
  }
});

export default i18n;
